// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__33ycD","noInteraction":"EventWrapper_noInteraction__tCLw_","pointerPassthrough":"EventWrapper_pointerPassthrough__4ezUi"};